import { Link } from "react-router-dom";

import ArrowLeft from "../../components/LogoSVG/ArrowLeft";

const FullProjectsPageMobile = () => {
  return <div className="mx-auto max-w-[730px] px-6 pb-44 pt-20"></div>;
};

export default FullProjectsPageMobile;
